import { Text } from '@twilio-paste/core/text';

import { DataGridEmptyState } from '../../common/DataGrid';

export function TargetsTableEmptyState() {
  return (
    <DataGridEmptyState colSpan={5}>
      <Text as="p" fontSize="fontSize40" marginBottom="space70">
        No targets found.
      </Text>
    </DataGridEmptyState>
  );
}
